var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8395 8.94254C16.6528 8.94254 16.4805 8.94254 16.4805 8.94254C17.3871 8.94254 18.3387 8.94254 18.6085 8.94254C18.8782 8.94254 19.2154 9.13735 19.3728 9.38462C19.5226 9.63189 20.3693 10.9581 21.2535 12.3518L24.9925 18.2413M1.01499 18.2413L4.78397 12.4268C5.68312 11.0406 6.55231 9.69183 6.72465 9.42958C6.89698 9.15983 7.27163 8.94254 7.56386 8.94254C7.85608 8.94254 8.7927 8.94254 9.6544 8.94254C9.6544 8.94254 9.47457 8.94254 11.2204 8.94254M25 18.2938C25 18.2638 24.9775 18.2413 24.955 18.2413C24.9326 18.2413 23.6887 18.2413 22.1901 18.2488C20.6915 18.2488 19.3878 18.2488 19.2829 18.2488C19.178 18.2488 18.5785 19.0805 17.9341 20.1146C17.2897 21.1486 15.4315 21.9878 13.7755 21.9878H12.7265C11.0706 21.9878 9.12989 21.1486 8.39558 20.1146C7.66127 19.0805 6.97191 18.2413 6.85952 18.2413C6.74712 18.2413 5.39839 18.2413 3.85482 18.2413C2.31127 18.2413 1.04496 18.2413 1.02997 18.2413C1.01499 18.2413 1.00749 18.2638 1.00749 18.2863C1.00749 18.3087 1.00749 19.6725 1 21.3284V21.778C1 23.4339 2.34124 24.7752 3.9897 24.7752H21.9953C23.6513 24.7752 24.9925 23.4339 25 21.778V21.3434C25 19.6875 25 18.3237 25 18.2938Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86133 13.1986L13.0349 17.3721L17.231 13.1761M13.0274 17.3721V1.22479",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 15.1304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSummary);
export default __webpack_public_path__ + "static/media/downloadSummary.9b1f4e6db26a91bceffa7ffd2258f294.svg";
export { ForwardRef as ReactComponent };